// Mail connections as the apps see them: the shape the owner may read, and
// the words shown when a Microsoft sign-in sends the user back.

/** How a mailbox is signed in to. */
export type MailAuth = 'password' | 'microsoft';

/** One of the owner's connected mailboxes: what the owner may read, never a secret. */
export interface MailConnection {
  id: string;
  host: string;
  username: string;
  auth: MailAuth;
  needs_reconnect: boolean;
  last_error: string | null;
  connected_at: string;
  last_checked_at: string | null;
  /** When the mailbox was last read; null before the first read. */
  last_sync_at: string | null;
  /** The last read stopped with more to read; the next one follows at once. */
  sync_backlog: boolean;
}

/** What the Integrations page says after a Microsoft mailbox sign-in sends the user back (?mail=...), or null for anything else. */
export function mailReturnMessage(outcome: string | null): { ok: boolean; message: string } | null {
  switch (outcome) {
    case 'connected':
      return { ok: true, message: 'Your Outlook.com mailbox is connected.' };
    case 'cancelled':
      return { ok: false, message: 'The mailbox was not connected: you cancelled on Microsoft.' };
    case 'expired':
      return { ok: false, message: 'The mailbox was not connected: that sign-in link expired or was already used. Connect again.' };
    case 'refused':
      return { ok: false, message: 'The mailbox was not connected: Microsoft did not grant access to it.' };
    case 'imap_refused':
      return { ok: false, message: 'Microsoft signed you in, but the Outlook.com mail server refused that sign-in for IMAP. The Microsoft app may lack the IMAP permission.' };
    case 'no_address':
      return { ok: false, message: 'The mailbox was not connected: Microsoft did not say which mail address you signed in with.' };
    case 'failed':
      return { ok: false, message: 'The mailbox was not connected: something went wrong finishing the sign-in. Try again.' };
    default:
      return null;
  }
}
